<div class="invitedUserLinkWrapper">
    <button class="button button-renderer small" [title]="'users.invitedUsers.copyLink' | translate" (click)="copyInviteLink()">
        <i class="far fa-copy"></i>
    </button>
    @if (linkCopied) {
        <span>{{ 'users.invitedUsers.copied' | translate }}</span>
    }
</div>
